import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { PanelUserRoute } from '@/modules/user/routes/panel-user.route'
import { UpdatePasswordRequestModel } from '@/modules/user/models/user-request.model'

@vservice()
export class PanelUserService {
  constructor(
    private readonly routes: PanelUserRoute
  ) {
  }

  updateName(data) {
    return Inertia.put(
      this.routes.updateName(),
      data
    )
  }

  updatePassword(data: UpdatePasswordRequestModel) {
    return Inertia.put(
      this.routes.updatePassword(),
      data
    )
  }

  updateNotificationPreferences(data) {
    return Inertia.put(
      this.routes.updateNotificationPreferences(),
      data,
      {
        preserveScroll: true
      }
    )
  }

  updateBankAccount(data) {
    return Inertia.put(
      this.routes.updateBankAccount(),
      data
    )
  }

}